var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.34315 7L0.371311 2.02816C-0.0863347 1.57051 -0.086335 0.828522 0.371311 0.370876C0.828956 -0.0867699 1.57095 -0.0867703 2.02859 0.370875L7.00043 5.34272L11.9723 0.370874C12.4299 -0.0867705 13.1719 -0.0867712 13.6296 0.370874C14.0872 0.82852 14.0872 1.57051 13.6296 2.02816L8.65771 7L13.6296 11.9718C14.0872 12.4295 14.0872 13.1715 13.6296 13.6291C13.1719 14.0868 12.4299 14.0868 11.9723 13.6291L7.00043 8.65728L2.02859 13.6291C1.57095 14.0868 0.828956 14.0868 0.371311 13.6291C-0.0863351 13.1715 -0.0863349 12.4295 0.371311 11.9718L5.34315 7Z",
    fill: "#252733"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0dd3b0ffce4bce13f51b920b709d3348.svg";
export { ForwardRef as ReactComponent };